import axios from 'axios';
import { StatusCodes } from 'http-status-codes';
import { HttpRequestException, UnspecifiedErrorCode, HttpRequestMethod, } from '@injectivelabs/exceptions';
import HttpClient from './HttpClient.js';
const getErrorMessage = (error, endpoint) => {
    if (!error.response) {
        return `The request to ${endpoint} has failed.`;
    }
    return error.response.data
        ? error.response.data.message ||
            error.response.data.statusMessage ||
            error.response.data
        : error.response.statusText;
};
/**
 * @hidden
 */
export default class HttpRestClient {
    client;
    endpoint;
    constructor(endpoint, options = {}) {
        this.client = new HttpClient(endpoint, options);
        this.endpoint = endpoint;
    }
    setConfig(config) {
        this.client.setConfig(config);
        return this;
    }
    async get(endpoint, params = {}) {
        try {
            return await this.client.get(endpoint, params);
        }
        catch (e) {
            const error = e;
            if (axios.isAxiosError(error)) {
                if (error.code === 'ECONNABORTED') {
                    throw new HttpRequestException(new Error(error.message), {
                        code: StatusCodes.REQUEST_TOO_LONG,
                        context: endpoint,
                    });
                }
                const message = getErrorMessage(error, endpoint);
                throw new HttpRequestException(new Error(message), {
                    context: endpoint,
                    code: error.response
                        ? error.response.status
                        : StatusCodes.BAD_REQUEST,
                });
            }
            throw new HttpRequestException(new Error(error.message), {
                code: UnspecifiedErrorCode,
                context: endpoint,
            });
        }
    }
    async retry(httpCall, retries = 3, delay = 1000) {
        const retryHttpCall = async (attempt = 1) => {
            try {
                return (await httpCall());
            }
            catch (e) {
                if (e instanceof HttpRequestException) {
                    if (e.code === StatusCodes.REQUEST_TOO_LONG) {
                        throw e;
                    }
                }
                if (attempt >= retries) {
                    throw e;
                }
                return new Promise((resolve) => setTimeout(() => resolve(retryHttpCall(attempt + 1)), delay * attempt));
            }
        };
        return retryHttpCall();
    }
    async post(endpoint, params = {}) {
        try {
            return await this.client.post(endpoint, params);
        }
        catch (e) {
            const error = e;
            if (axios.isAxiosError(error)) {
                if (error.code === 'ECONNABORTED') {
                    throw new HttpRequestException(new Error(error.message), {
                        code: StatusCodes.REQUEST_TOO_LONG,
                        method: HttpRequestMethod.Post,
                    });
                }
                const message = getErrorMessage(error, endpoint);
                throw new HttpRequestException(new Error(message), {
                    code: error.response
                        ? error.response.status
                        : StatusCodes.BAD_REQUEST,
                    context: endpoint,
                    contextModule: HttpRequestMethod.Post,
                });
            }
            throw new HttpRequestException(new Error(error.message), {
                code: UnspecifiedErrorCode,
                context: endpoint,
                contextModule: HttpRequestMethod.Post,
            });
        }
    }
}
